import { Ic2D, Ic3D } from '@assets/icons/40x40/mapMenu';
import { Icon, VStack } from '@chakra-ui/react';
import { useMapContext } from '@components/map/MapContext';
import { ButtonBar } from '@components/ui/buttonBar';

export default function DimensionControl() {
  const { viewMode, setViewMode } = useMapContext();
  const is2DActive = viewMode === '2D';

  return (
    <VStack padding={0} gap={0.25} width="100%">
      <ButtonBar.Root
        aria-label="2D"
        size="dimensionSelect"
        tooltipPlacement="left"
        data-active={is2DActive}
        notch={false}
        disabled={is2DActive}
        onClick={() => setViewMode('2D')}
        _disabled={{
          color: 'skyBlue',
          backgroundColor: 'neutral.700',
        }}
      >
        <ButtonBar.Control>
          <Icon as={Ic2D} />
        </ButtonBar.Control>
      </ButtonBar.Root>
      <ButtonBar.Root
        size="dimensionSelect"
        aria-label="3D"
        tooltipPlacement="left"
        data-active={!is2DActive}
        notch={false}
        disabled={!is2DActive}
        onClick={() => setViewMode('3D')}
        _disabled={{
          color: 'skyBlue',
          backgroundColor: 'neutral.700',
        }}
      >
        <Icon as={Ic3D} />
      </ButtonBar.Root>
    </VStack>
  );
}
